import React, { useState } from "react";
import { X, Tag, Coins } from "lucide-react";

const BillComponent = ({ 
  topProducts, 
  bill, 
  coins, 
  coupon, 
  couponText, 
  setCouponText,
  validateCoupon,
  cancelCoupon,
  appliedCoins,
  setAppliedCoins,
  coinInput,
  setCoinInput,
  handleInputChange,
  applyCoins,
  handleCoinCancel,
  isloggedIn,
  handleContinue,
  navigate 
}) => {
  const [showInput, setShowInput] = useState(false);

  return (
    <>
      {topProducts && topProducts.length !== 0 ? (
        <div className="bg-white border border-gray-200 rounded-lg p-4 h-fit max-xs:!px-2">
          {/* Header */}
          <div className="text-sm font-semibold text-gray-900 mb-4 pb-3 border-b border-gray-100">
            Price Details ({topProducts.length} Items)
          </div>

          {/* Coupon Section */}
          <div className="mb-4">
            {!coupon ? (
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="Apply coupon..."
                  value={couponText}
                  onChange={(e) => setCouponText(e.target.value)}
                  className="flex-1 px-3 py-2 text-xs border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                />
                <button 
                  onClick={validateCoupon}
                  className="px-4 py-2 bg-orange-500 text-white text-xs font-medium rounded-lg hover:bg-orange-600 transition-colors"
                >
                  Apply
                </button>
              </div>
            ) : (
              <div className="relative bg-green-50 border border-green-200 rounded-lg p-3 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Tag className="w-4 h-4 text-green-600" />
                  <span className="text-xs font-medium text-green-700">Coupon Applied</span>
                </div>
                <button
                  onClick={cancelCoupon}
                  className="text-green-600 hover:text-green-800 transition-colors"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            )}
          </div>

          {/* Coins Section */}
        {/*   <div className="mb-4">
            {showInput ? (
              <div className="flex gap-2">
                <input
                  type="text"
                  value={coinInput}
                  onChange={handleInputChange}
                  placeholder="Enter coins"
                  className="flex-1 px-3 py-2 text-xs border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                />
                <button 
                  onClick={applyCoins}
                  className="px-4 py-2 bg-orange-500 text-white text-xs font-medium rounded-lg hover:bg-orange-600 transition-colors"
                >
                  Add
                </button>
              </div>
            ) : appliedCoins > 0 ? (
              <div className="flex items-center justify-between bg-orange-50 border border-orange-200 rounded-lg p-3">
                <div className="flex items-center gap-2">
                  <Coins className="w-4 h-4 text-orange-600" />
                  <span className="text-xs font-medium text-orange-700">
                    {appliedCoins} coins used
                  </span>
                </div>
                <button
                  onClick={handleCoinCancel}
                  className="px-3 py-1 bg-orange-500 text-white text-xs rounded hover:bg-orange-600 transition-colors"
                >
                  Cancel
                </button>
              </div>
            ) : (
              <button
                onClick={() => setShowInput(true)}
                className="w-full p-3 border border-gray-200 rounded-lg hover:border-orange-200 hover:bg-orange-50 transition-colors text-left"
              >
                <div className="flex items-center gap-2">
                  <Coins className="w-4 h-4 text-gray-500" />
                  <span className="text-xs font-medium text-gray-700">Use coins</span>
                  <span className="text-xs text-gray-500">({coins} available)</span>
                </div>
              </button>
            )}
          </div> */}

          {/* Bill Details */}
          {bill && (
            <div className="space-y-3 mb-4">
              {/* Items */}
              {bill.items.map((item, index) => (
                <div key={index} className="flex justify-between items-start text-xs">
                  <span className="text-gray-700 flex-1 pr-2">{item.product}</span>
                  <span className="font-medium text-gray-900">₹{item.price}</span>
                </div>
              ))}
              
              {/* Discount */}
              {bill.discount > 0 && (
                <div className="flex justify-between items-center text-xs pt-2 border-t border-gray-100">
                  <span className="text-green-600">Discount</span>
                  <span className="font-medium text-green-600">-₹{bill.discount}</span>
                </div>
              )}
              
              {/* Shipping */}
              <div className="flex justify-between items-center text-xs">
                <span className="text-gray-700">Shipping Cost</span>
                <span className="font-medium text-gray-900">
                  {bill.shipping === 0 ? "Free" : `₹${bill.shipping}`}
                </span>
              </div>
              
              {/* GST */}
              <div className="flex justify-between items-center text-xs">
                <span className="text-gray-700">Goods and Services Tax</span>
                <span className="font-medium text-gray-900">₹{bill.gst}</span>
              </div>
              
              {/* Total */}
              <div className="flex justify-between items-center text-sm font-semibold pt-3 border-t border-gray-200">
                <span className="text-gray-900">Total Cost</span>
                <span className="text-gray-900">₹{bill.finalPrice}</span>
              </div>
            </div>
          )}

          {/* Continue Button */}
          <div className="mt-6">
            {isloggedIn ? (
              <button 
                onClick={handleContinue}
                className="w-full bg-orange-500 text-white py-3 rounded-lg font-medium text-sm hover:bg-orange-600 transition-colors duration-200"
              >
                Continue
              </button>
            ) : (
              <button
                onClick={() => navigate("/log-in")}
                className="w-full bg-gray-500 text-white py-3 rounded-lg font-medium text-sm hover:bg-gray-600 transition-colors duration-200"
              >
                Please login to Continue
              </button>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default BillComponent;